import { Controller } from "@hotwired/stimulus"

// 目次(TOC)マクロ: 表示ページの `[data-macro="toc"]` を、本文の見出し(h1-h5[id])から
// 生成した入れ子リンクリストで埋める。見出し id (Confluence 互換アンカー) を参照。
export default class extends Controller {
  connect() {
    const macros = this.element.querySelectorAll('[data-macro="toc"]')
    if (macros.length === 0) return

    const headings = [...this.element.querySelectorAll("h1[id],h2[id],h3[id],h4[id],h5[id]")]
      .map((h) => ({ level: Number(h.tagName[1]), id: h.id, text: this.headingText(h) }))

    macros.forEach((macro) => {
      macro.innerHTML = ""
      macro.classList.add("akebono-toc")
      macro.appendChild(this.titleEl())
      if (headings.length === 0) {
        macro.appendChild(this.emptyMessage())
      } else {
        macro.appendChild(this.buildList(headings))
      }
    })
  }

  titleEl() {
    const t = document.createElement("div")
    t.className = "akebono-macro-title"
    t.textContent = "📑 目次"
    return t
  }

  // 🔗 コピーボタン等の付随テキストを除いた見出し本文
  headingText(h) {
    const clone = h.cloneNode(true)
    clone.querySelectorAll(".akebono-heading-anchor").forEach((b) => b.remove())
    return clone.textContent.trim()
  }

  // 最小レベルを基準に入れ子 <ul> を構築
  buildList(headings) {
    const min = Math.min(...headings.map((h) => h.level))
    const root = document.createElement("ul")
    const stack = [{ level: min - 1, ul: root }]

    headings.forEach((h) => {
      while (stack.length > 1 && stack[stack.length - 1].level >= h.level) stack.pop()
      let parent = stack[stack.length - 1].ul
      // レベルが飛んだ場合は中間 <ul> を補う
      while (stack[stack.length - 1].level < h.level - 1) {
        const li = parent.lastElementChild || parent.appendChild(document.createElement("li"))
        const sub = document.createElement("ul")
        li.appendChild(sub)
        stack.push({ level: stack[stack.length - 1].level + 1, ul: sub })
        parent = sub
      }
      const li = document.createElement("li")
      const a = document.createElement("a")
      a.href = `#${encodeURIComponent(h.id)}`
      a.textContent = h.text
      // Turbo Drive は hash をデコードせず id 照合するため、日本語 id だと飛べない。
      // 自前でジャンプ + アドレスバー反映し、ネイティブ/Turbo 双方の不整合を回避する。
      a.addEventListener("click", (e) => this.jumpTo(e, h.id))
      li.appendChild(a)
      parent.appendChild(li)
      const childUl = document.createElement("ul")
      li.appendChild(childUl)
      stack.push({ level: h.level, ul: childUl })
    })

    // 空の子 <ul> を掃除
    root.querySelectorAll("ul").forEach((ul) => { if (!ul.children.length) ul.remove() })
    return root
  }

  // 見出しへスクロールし、hash をアドレスバーに反映する。
  jumpTo(e, id) {
    const target = document.getElementById(id)
    if (!target) return
    e.preventDefault()
    target.scrollIntoView()
    history.replaceState(null, "", `#${encodeURIComponent(id)}`)
  }

  emptyMessage() {
    const p = document.createElement("p")
    p.className = "akebono-toc-empty"
    p.textContent = "（見出しがありません）"
    return p
  }
}
